/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';
import type { V2beta1Url } from './V2beta1Url';
import {
  V2beta1UrlFromJSON,
  V2beta1UrlFromJSONTyped,
  V2beta1UrlToJSON,
  V2beta1UrlToJSONTyped,
} from './V2beta1Url';

/**
 *
 * @export
 * @interface V2beta1PipelineVersion
 */
export interface V2beta1PipelineVersion {
  /**
   * Required input field. Unique ID of the parent pipeline.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof V2beta1PipelineVersion
   */
  pipeline_id?: string;
  /**
   * Output. Unique pipeline version ID. Generated by API server.
   * @type {string}
   * @memberof V2beta1PipelineVersion
   */
  pipeline_version_id?: string;
  /**
   * Required if name is not provided. Pipeline version display name provided by user.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof V2beta1PipelineVersion
   */
  display_name?: string;
  /**
   * Required if display_name is not provided. Pipeline version name provided by user.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof V2beta1PipelineVersion
   */
  name?: string;
  /**
   * Optional input field. Short description of the pipeline version.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof V2beta1PipelineVersion
   */
  description?: string;
  /**
   * Output. Creation time of the pipeline version.
   * @type {Date}
   * @memberof V2beta1PipelineVersion
   */
  created_at?: Date;
  /**
   *
   * @type {V2beta1Url}
   * @memberof V2beta1PipelineVersion
   */
  package_url?: V2beta1Url;
  /**
   * Input. Optional. The URL to the code source of the pipeline version.
   * The code is usually the Python definition of the pipeline and potentially
   * related the component definitions. This allows users to trace back to how
   * the pipeline YAML was created.
   * @type {string}
   * @memberof V2beta1PipelineVersion
   */
  code_source_url?: string;
  /**
   * Output. The pipeline spec for the pipeline version.
   * @type {object}
   * @memberof V2beta1PipelineVersion
   */
  pipeline_spec?: object;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof V2beta1PipelineVersion
   */
  error?: GoogleRpcStatus;
  /**
   * Optional input field. User-defined tags (key-value pairs) for the pipeline version.
   * Constraints:
   *   - Maximum 20 tags per pipeline version.
   *   - Both keys and values are limited to 63 characters.
   *   - Keys cannot be empty and must not contain the '.' character.
   * Tags are stored in a separate table and can be retrieved via Get and List APIs.
   * @type {{ [key: string]: string; }}
   * @memberof V2beta1PipelineVersion
   */
  tags?: { [key: string]: string };
}

/**
 * Check if a given object implements the V2beta1PipelineVersion interface.
 */
export function instanceOfV2beta1PipelineVersion(value: object): value is V2beta1PipelineVersion {
  return true;
}

export function V2beta1PipelineVersionFromJSON(json: any): V2beta1PipelineVersion {
  return V2beta1PipelineVersionFromJSONTyped(json, false);
}

export function V2beta1PipelineVersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PipelineVersion {
  if (json == null) {
    return json;
  }
  return {
    pipeline_id: json['pipeline_id'] == null ? undefined : json['pipeline_id'],
    pipeline_version_id:
      json['pipeline_version_id'] == null ? undefined : json['pipeline_version_id'],
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    package_url: json['package_url'] == null ? undefined : V2beta1UrlFromJSON(json['package_url']),
    code_source_url: json['code_source_url'] == null ? undefined : json['code_source_url'],
    pipeline_spec: json['pipeline_spec'] == null ? undefined : json['pipeline_spec'],
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function V2beta1PipelineVersionToJSON(json: any): V2beta1PipelineVersion {
  return V2beta1PipelineVersionToJSONTyped(json, false);
}

export function V2beta1PipelineVersionToJSONTyped(
  value?: V2beta1PipelineVersion | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_id: value['pipeline_id'],
    pipeline_version_id: value['pipeline_version_id'],
    display_name: value['display_name'],
    name: value['name'],
    description: value['description'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    package_url: V2beta1UrlToJSON(value['package_url']),
    code_source_url: value['code_source_url'],
    pipeline_spec: value['pipeline_spec'],
    error: GoogleRpcStatusToJSON(value['error']),
    tags: value['tags'],
  };
}
